module.exports = __webpack_public_path__ + "img/item3.ccc5389d.png";